
import React, { useState, useEffect, CSSProperties } from 'react';
import { ExitBtn, Page } from 'components/atoms';
import styles from "../ContentBlocks.module.css";
import { getAssetPath, getAssetPathAndSize } from 'utils';
import { TabbedContent } from 'components/organisms/TabbedContent/Desktop/Tab';
import { TabbedContentMobile } from 'components/organisms';
import Modal from "react-modal";
import classNames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import he from "he";
import { TextEditor } from 'components/molecules/TextEditor';
import { ReactModalStyles } from 'components/constants';

type Icon = {
    Alt: string,
    Src: string,
    Height: string,
    Width: string,
    Rendered: any,
    MimeType: string,
    Size: number
}

export const TabbedContentBlock = (props) => {
    /* Component State */
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [activeItem, setActiveItem] = useState<{ icon?: Icon, heading?: string, summary?: string, html?: string, idx: number }>({ html: "", idx: -1 });

    const {
        TextEditor: _TextEditor,
        isDesktop,
        DesktopImage,
        MobileImage,
        BackgroundColour,
        TabLinkPool } = props;

    /* Limit Tabs */
    const _TabLinkPool = TabLinkPool.slice(0, 5);

    const bgImage = isDesktop ? DesktopImage : MobileImage;

    /* Event Listener Fn's */
    const handleIsOpenChange = (bool: boolean) => {
        setIsOpen(bool);
        if(bool) document.querySelector('body').classList.add('no-scroll');
        if(!bool) document.querySelector('body').classList.remove('no-scroll');
    };

    const handleChangeActiveModalItem = (icon: Icon,
        heading: string, 
        summary: string,
         html: string, 
         idx: number) => {
        setActiveItem({ icon: icon, heading: heading, summary: summary, html: html, idx: idx });
    };

    return (
        <div
            className={styles.TabbedContentBlockModelContent}
            style={{
                '--tabBgColor': !Boolean(bgImage?.Src) ? BackgroundColour?.Value : '',
                backgroundImage: `url(${getAssetPathAndSize(bgImage?.Src, 100, 2)})`
            } as CSSProperties}>
            <Page className="noPadding" key="TabbedContentBlockModel">
                {isDesktop ?
                    <TabbedContent
                        TextEditor={_TextEditor}
                        DesktopImage={DesktopImage}
                        MobileImage={MobileImage}
                        BackgroundColour={BackgroundColour}
                        TabLinkPool={_TabLinkPool}
                    />
                    :
                    <TabbedContentMobile
                        handleChangeActiveModalItem={(icon: Icon,
                             heading: string, 
                             summary: string,
                              html: string, 
                              idx: number) => handleChangeActiveModalItem(icon, heading, summary, html, idx)}
                        handleShowModal={() => handleIsOpenChange(true)}
                        TextEditor={_TextEditor}
                        DesktopImage={DesktopImage}
                        MobileImage={MobileImage}
                        BackgroundColour={BackgroundColour}
                        TabLinkPool={_TabLinkPool}
                    >
                        <Modal
                            style={{...ReactModalStyles}}
                            isOpen={isOpen && activeItem}
                            className={classNames("Modal")}
                            onRequestClose={() => handleIsOpenChange(false)}
                            shouldCloseOnOverlayClick={true}
                        >
                            {isOpen &&
                                <AnimatePresence exitBeforeEnter>
                                    <motion.div
                                        initial={{ opacity: 0, top: 200 }}
                                        animate={{ opacity: 1, top: 0 }}
                                        exit={{ opacity: 0, top: 200 }}
                                        className={classNames(styles.tabModalWrapper, "tabbed-content")}
                                    >
                                        <div><img src={getAssetPath(activeItem.icon.Src)} alt={activeItem.icon.Alt}/></div>
                                        <div><h1>{he.decode(activeItem.heading)}</h1></div>
                                        <div><h3>{he.decode(activeItem.summary)}</h3></div>
                                        <TextEditor
                                            isDesktop={isDesktop}
                                            className="tabbed-content"
                                            key={'tab-mobile-active-item-' + activeItem.idx}
                                            data={activeItem.html} />
                                        <ExitBtn style={{ top: '20px', right: '20px' }} handleIsOpenChange={() => handleIsOpenChange(false)} />
                                    </motion.div>

                                </AnimatePresence>
                            }

                        </Modal>
                    </TabbedContentMobile>
                }

            </Page>
        </div>
    )
};
